import type { JSX } from "react";
import { DataTableHead, DataTableHeader } from "@linkhr/design-system";
import { useTranslation } from "@linkhr/i18n";

/** Account, description, contact, branch, cost centre, then Debit before Credit (Debit sits right in RTL). */
export function GridHead({
  removable = false,
  brief = false,
}: {
  removable?: boolean;
  brief?: boolean;
}): JSX.Element {
  const { t } = useTranslation("accounting");
  return (
    <DataTableHeader>
      <tr>
        <DataTableHead>{t("accounting:journal.columns.account")}</DataTableHead>
        <DataTableHead>{t("accounting:journal.columns.description")}</DataTableHead>
        {brief ? null : (
          <>
            <DataTableHead>{t("accounting:journal.columns.contact")}</DataTableHead>
            <DataTableHead>{t("accounting:journal.columns.branch")}</DataTableHead>
            <DataTableHead>{t("accounting:journal.columns.cost_centre")}</DataTableHead>
          </>
        )}
        <DataTableHead className="text-end">{t("accounting:journal.columns.debit")}</DataTableHead>
        <DataTableHead className="text-end">{t("accounting:journal.columns.credit")}</DataTableHead>
        {removable ? (
          <DataTableHead>
            <span className="sr-only">{t("accounting:journal.remove_line")}</span>
          </DataTableHead>
        ) : null}
      </tr>
    </DataTableHeader>
  );
}
